import { APIClient, ApiQueryParams } from '@frontend/api-utils';
import { ChangeListResponse, ChangeQueryParams } from '@frontend/sync/types';

export class ChangeClient extends APIClient {
    public static async fetchServiceChanges(serviceName: string, queryParams?: ApiQueryParams<ChangeQueryParams>): Promise<ChangeListResponse> {
        return await this.apiPaginated<ChangeListResponse, ChangeQueryParams>(`/${serviceName}/v1/changes`, queryParams);
    }

    public static async fetchRemoteChanges(serviceName: string, accountId: string, queryParams?: ApiQueryParams<ChangeQueryParams>): Promise<ChangeListResponse> {
        return await this.apiPaginated<ChangeListResponse, ChangeQueryParams>(`/${serviceName}/v1/accounts/${accountId}/remote-changes`, queryParams);
    }

    public static async fetchSync(serviceName: string, accountId: string, queryParams?: ApiQueryParams<ChangeQueryParams>): Promise<void> {
        const response = await this.fetch(`/${serviceName}/v1/accounts/${accountId}/sync`, queryParams);
        return this.handleVoidResponse(response);
    }
}
